export default __webpack_public_path__ + "static/media/user-avatar.6dd031a2.jpg";